<template>
  <esg-table-without-meta :fields="fields"
                          :items="items"
                          :filter="false"
                          max-height="300px"
                          size="sm">
    <template #cell(category)="{item, items, field, row, col, value}">
      <td v-if="item.rowspan && item.rowspan.category">{{ value }}</td>
      <!--  더미 HTML 엘레멘트    -->
      <td v-else
          style="border-top: none"></td>
    </template>
    <template #cell(subcategory)="{item, items, field, row, col, value}">
      <td v-if="item.rowspan && item.rowspan.subcategory">{{ value }}</td>
      <!--  더미 HTML 엘레멘트    -->
      <td v-else
          style="border-top: none"></td>
    </template>
    <template #cell(2021)="{item, items, field, row, col, value}">
      <td class="text-center">{{ item.unit === '명' ? value : formatNumber(value, 1) }}</td>
    </template>
    <template #cell(2022)="{item, items, field, row, col, value}">
      <td class="text-center">{{ item.unit === '명' ? value : formatNumber(value, 1) }}</td>
    </template>
    <template #cell(2023)="{item, items, field, row, col, value}">
      <td class="text-center">{{ item.unit === '명' ? value : formatNumber(value, 1) }}</td>
    </template>
  </esg-table-without-meta>
</template>

<script>
import EsgTableWithoutMeta from "@/components/esg/base/EsgTableWithoutMeta.vue";

export default {
  name: "SocialDataTable",
  components: {EsgTableWithoutMeta},
  data() {
    return {
      fields: [
        {name: 'category', label: '분류', list: true, type: 'String',},
        {name: 'subcategory', label: '구분', list: true, type: 'String',},
        {name: 'item', label: '항목', list: true, type: 'String',},
        {name: 'unit', label: '단위', list: true, type: 'String',},
        {name: '2021', label: '2021', list: true, type: 'Number',},
        {name: '2022', label: '2022', list: true, type: 'Number',},
        {name: '2023', label: '2023', list: true, type: 'Number',},
      ],
      items: [
        {
          category: '총 임직원 수',
          subcategory: null,
          item: null,
          unit: '명',
          '2021': 1422,
          '2022': 1746,
          '2023': 2070,
          rowspan: {
            category: 1
          }
        },
        {
          category: '임직원 수',
          subcategory: null,
          item: '남성',
          unit: '명',
          '2021': 468,
          '2022': 630,
          '2023': 792,
          rowspan: {
            category: 2,
            subcategory: 2,
          }
        },
        {
          category: '임직원 수',
          subcategory: null,
          item: '여성',
          unit: '명',
          '2021': 954,
          '2022': 1116,
          '2023': 1278,
        },
        {
          category: '정규직 현황',
          subcategory: '인원',
          item: '남성',
          unit: '명',
          '2021': 126,
          '2022': 207,
          '2023': 288,
          rowspan: {
            category: 6,
            subcategory: 3
          }
        },
        {
          category: '정규직 현황',
          subcategory: '인원',
          item: '여성',
          unit: '명',
          '2021': 369,
          '2022': 450,
          '2023': 531,
        },
        {
          category: '정규직 현황',
          subcategory: '인원',
          item: '전체',
          unit: '명',
          '2021': 495,
          '2022': 657,
          '2023': 819,
        },
        {
          category: '정규직 현황',
          subcategory: '비율',
          item: '남성',
          unit: '%',
          '2021': 8.9,
          '2022': 12,
          '2023': 13.9,
          rowspan: {
            subcategory: 3,
          }
        },
        {
          category: '정규직 현황',
          subcategory: '비율',
          item: '여성',
          unit: '%',
          '2021': 25.9,
          '2022': 25.8,
          '2023': 25.7,
        },
        {
          category: '정규직 현황',
          subcategory: '비율',
          item: '전체',
          unit: '%',
          '2021': 34.8,
          '2022': 37.6,
          '2023': 39.6,
        },

        {
          category: '계약직 현황',
          subcategory: '인원',
          item: '남성',
          unit: '명',
          '2021': 342,
          '2022': 423,
          '2023': 504,
          rowspan: {
            category: 6,
            subcategory: 3
          }
        },
        {
          category: '계약직 현황',
          subcategory: '인원',
          item: '여성',
          unit: '명',
          '2021': 585,
          '2022': 666,
          '2023': 747,
        },
        {
          category: '계약직 현황',
          subcategory: '인원',
          item: '전체',
          unit: '명',
          '2021': 929,
          '2022': 1089,
          '2023': 1251,
        },

        {
          category: '계약직 현황',
          subcategory: '비율',
          item: '남성',
          unit: '%',
          '2021': 24.1,
          '2022': 24,
          '2023': 24.3,
          rowspan: {
            subcategory: 3
          }
        },
        {
          category: '계약직 현황',
          subcategory: '비율',
          item: '여성',
          unit: '%',
          '2021': 41.1,
          '2022': 38.1,
          '2023': 36.1,
        },
        {
          category: '계약직 현황',
          subcategory: '비율',
          item: '전체',
          unit: '%',
          '2021': 65.2,
          '2022': 62.4,
          '2023': 60.4,
        },

        {
          category: '연령별 임직원 수',
          subcategory: null,
          item: '30세 미만',
          unit: '명',
          '2021': 462,
          '2022': 570,
          '2023': 678,
          rowspan: {
            category: 3,
            subcategory: 3
          }
        },
        {
          category: '연령별 임직원 수',
          subcategory: null,
          item: '30~50세',
          unit: '명',
          '2021': 474,
          '2022': 582,
          '2023': 690,
        },
        {
          category: '연령별 임직원 수',
          subcategory: null,
          item: '50세 초과',
          unit: '명',
          '2021': 486,
          '2022': 594,
          '2023': 702,
        },
        {
          category: '연령별 임직원 수',
          subcategory: null,
          item: '전체',
          unit: '명',
          '2021': 1422,
          '2022': 1746,
          '2023': 2070,
        },
      ]
    }
  }
}
</script>
